/* eslint-disable max-len */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-vars */
import { useState, useEffect } from 'react';
import moment from 'moment';
import { toastSuccess, toastError } from '../../../../redux/actions/alertActions';
import evaluoServices from '../../../../redux/services/evaluoServices';

const useEvaluoExam = (company, refresh, setRefresh) => {
  const addEvaluoExam = async (form, catchUp, subject) => {
    const body = {
      evaluoData: {
        name: `${company.name} ${form.semester.label}${catchUp ? ' - Rattrapage' : ''}`,
        category: form.modality.value,
        start_at: moment(new Date(form.beginDate)).format('YYYY-MM-DD HH:mm:ss').toString(),
        end_at: moment(new Date(form.endDate)).format('YYYY-MM-DD HH:mm:ss').toString(),
        duration: `${Math.floor(form.duration.value / 60) < 10 ? '0' : ''}${Math.floor(form.duration.value / 60)}:${form.duration.value % 60 < 10 ? '0' : ''}${form.duration.value % 60}:00`,
        start_auto: true,
        end_auto: true,
        identify_portrait: form.identifyPortrait,
        identify_paper: form.identifyPaper,
        identify_environment: form.identifyEnvironment,
        identify_validation_required: form.identifyValidationRequired,
        secure: form.secure,
        secure_type_id: form.secure ? 1 : 0,
        secure_level_id: form.secureLevelId.value,
        secure_clipboard: form.secureClipboard,
        secure_dualscreen: form.secureDualscreen,
        secure_fullscreen: form.secureFullscreen,
        student_lock: form.studentLock,
        proctoring: form.proctoring,
        proctoring_type_id: form.proctoringTypeId.value,
        proctoring_camera: form.proctoringCamera,
        proctoring_screen: form.proctoringScreen,
        proctoring_bypass: true,
        plagiarism_type: form.plagiarismType.value,
        student_show_countdown: true,
        student_allow_draft: true,
        student_paper_visibility: true,
        student_retake: form.studentRetake,
        corrector_anonymize: form.correctorAnonymize,
        attendance_signature: form.attendanceSignature,
        student_marking_visibility_id: 3, // 1: après la fin de toutes les corrections / 2: après la fin de la correction de l'élève / 3: jamais
      },
      companyId: company._id,
      semester: form.semester.value,
      subject: subject.value,
    };
    const exam = await evaluoServices.addEvaluoExam(body);
    setRefresh(!refresh);
    if (exam.data) {
      toastSuccess('Exam created successfully');
    } else {
      toastError('Failed to create exam');
    }
  };

  const updateEvaluoExam = async (examId, form, subject, oldSubjectId) => {
    const body = {
      evaluoData: {
        category: form.modality.value,
        start_at: moment(new Date(form.beginDate)).format('YYYY-MM-DD HH:mm:ss').toString(),
        end_at: moment(new Date(form.endDate)).format('YYYY-MM-DD HH:mm:ss').toString(),
        duration: `${Math.round(form.duration.value / 60) < 10 ? '0' : ''}${Math.round(form.duration.value / 60)}:${form.duration.value % 60 < 10 ? '0' : ''}${form.duration.value % 60}:00`,
        start_auto: true,
        end_auto: true,
        identify_portrait: form.identifyPortrait,
        identify_paper: form.identifyPaper,
        identify_environment: form.identifyEnvironment,
        identify_validation_required: form.identifyValidationRequired,
        secure: form.secure,
        secure_type_id: form.secure ? 1 : 0,
        secure_level_id: form.secure ? form.secureLevelId.value : 0,
        secure_clipboard: form.secure ? form.secureClipboard : false,
        secure_dualscreen: form.secure ? form.secureDualscreen : false,
        secure_fullscreen: form.secure ? form.secureFullscreen : false,
        student_lock: form.studentLock,
        proctoring: form.proctoring,
        proctoring_type_id: form.proctoring ? form.proctoringTypeId.value : 0,
        proctoring_camera: form.proctoring ? form.proctoringCamera : false,
        proctoring_screen: form.proctoring ? form.proctoringScreen : false,
        proctoring_bypass: true,
        plagiarism_type: form.plagiarismType.value,
        // plagiarism_global_rate: 25,
        student_show_countdown: true,
        student_allow_draft: true,
        student_paper_visibility: true,
        student_retake: form.studentRetake,
        corrector_anonymize: form.correctorAnonymize,
        attendance_signature: form.attendanceSignature,
        student_marking_visibility_id: 3,
      },
      subject: subject.value,
      oldSubjectId,
    };
    const exam = await evaluoServices.updateEvaluoExam(examId, body);
    if (exam.response !== 'error') {
      setRefresh(!refresh);
      toastSuccess('Exam updated successfully');
    } else {
      toastError('Failed to update exam');
    }
  };

  const deleteEvaluoExam = async (examId) => {
    const exam = await evaluoServices.deleteEvaluoExam(examId);
    setRefresh(!refresh);
    if (exam.message) {
      toastSuccess('Exam deleted successfully');
    } else {
      toastError('Failed to delete exam');
    }
  };

  return {
    addEvaluoExam,
    updateEvaluoExam,
    deleteEvaluoExam,
  };
};

export default useEvaluoExam;
